// ========================================
// Dashboard Component
// ========================================
// Main dashboard with welcome section and quick access

import { useAuth } from '../Auth/AuthContext';
import { useCheckIns } from '../../hooks/useCheckIns';
import { getDailyQuote } from '../../utils/quotes';
import QuickAccessCard from './QuickAccessCard';
import RecentActivity from './RecentActivity';
import './Dashboard.css';

const Dashboard = () => {
  const { userProfile } = useAuth();
  const { recentCheckIn, loading } = useCheckIns();
  const quote = getDailyQuote();

  const firstName = userProfile?.name?.split(' ')[0] || 'there';

  return (
    <div className="dashboard-container">
      <div className="dashboard-content">
        {/* Welcome Section */}
        <section className="welcome-section glass-panel">
          <h1 className="welcome-title">Welcome back, {firstName}</h1>
          <p className="welcome-subtitle">How are you feeling today?</p>

          <div className="daily-quote">
            <p className="quote-text">"{quote.text}"</p>
            <p className="quote-author">— {quote.author}</p>
          </div>
        </section>

        {/* Quick Access Cards */}
        <section className="quick-access-section">
          <h2 className="section-title">Quick Access</h2>

          <div className="quick-access-grid">
            <QuickAccessCard
              title="Feelings Check-in"
              description="Track your emotions across life categories"
              icon="❤️"
              to="/checkin"
              color="primary"
            />

            <QuickAccessCard
              title="Gratitude List"
              description="Celebrate what you're grateful for"
              icon="🙏"
              to="/gratitude"
              color="secondary"
            />

            <QuickAccessCard
              title="Process Resentments"
              description="Work through difficult emotions"
              icon="🌱"
              to="/resentments"
              color="tertiary"
            />

            <QuickAccessCard
              title="Check-in History"
              description="View your emotional patterns over time"
              icon="📊"
              to="/checkin/history"
              color="accent"
            />
          </div>
        </section>

        {/* Recent Activity */}
        <section className="recent-activity-section">
          <h2 className="section-title">Recent Activity</h2>
          <RecentActivity recentCheckIn={recentCheckIn} loading={loading} />
        </section>
      </div>
    </div>
  );
};

export default Dashboard;
